import React, { FC } from "react";
import styles from "./MobileNavbar.module.css";
import logo from "../../../assets/logo.svg";

interface MobileNavbarProps {}

const MobileNavbar: FC<MobileNavbarProps> = () => {
  return (
    <div>
      <div className={styles.Navbar}>
        <div className={styles.Brand}>
          <div className={styles.Image}>
            <img src={logo} alt="logo" />
          </div>
          <div className={styles.Title}>iK Invoice</div>
        </div>
      </div>
    </div>
  );
};

export default MobileNavbar;
